import { Select } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import {
  type ReportAccessSubmitActionOption,
  useReportAccessSubmitActionOptions,
} from './useReportAccessSubmitActionOptions'
import { type ReportAccessSubmitActionEnum } from '../../enums'

export interface IReportAccessSubmitActionSelectProps {
  value: ReportAccessSubmitActionEnum
  onChange: (action: ReportAccessSubmitActionEnum) => void
}

/**
 * Presentational Feature Set subcomponent — the ADD/REMOVE action of the
 * all-PrimaryCategories picker row.
 */
export const ReportAccessSubmitActionSelect = ({
  value,
  onChange,
}: IReportAccessSubmitActionSelectProps) => {
  const intl = useProcurifyIntl()
  const options = useReportAccessSubmitActionOptions()

  return (
    <Select<ReportAccessSubmitActionOption>
      aria-label={intl.formatMessage(messages.ariaLabel)}
      options={options}
      value={options.find((option) => option.value === value)}
      onChange={(option) => {
        if (option) onChange(option.value)
      }}
      isSearchable={false}
    />
  )
}

ReportAccessSubmitActionSelect.displayName = 'ReportAccessSubmitActionSelect'
